import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const LatestNews = () => {
    return (
        <div className="latest-news-wrapper  xmt-16  xmt-lg-20">
            <div className="container">
                <div className="title">
                    <div className="title-box just-text title-box-blue">
                        <div className="title-bg">
                                <h2 className="text">
                                    آخرین مطالب
                                </h2>
                        </div>
                        <div className="more">
                            <span className="d-none d-sm-inline"><a href="#">بیشتر</a></span>
                            <a href="#"><IconName name="chevron_left" className="icon"/></a>
                        </div>
                    </div>
                </div>
                <div className="latest-news-slider">
                    <div className="d-none d-lg-block">
                        <div className="swiper latest-news-swiper  position-relative">
                            <div className="swiper-scrollbar-news position-absolute">
                            </div>
                            <div className="swiper-wrapper">

                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="news-box">
                                            <div className="news-img">
                                                <img src="./assets/sample-image/5-2-1280x720.png" className="img-fluid"
                                                     alt="گوشی موبایل"/>
                                            </div>
                                            <div className="news-info xp-4">
                                                <div className="news-text">
                                                    <h2>می‌ بند ۵ معرفی شد: تغییراتی جذاب در مقایسه با نسخه‌ی قبلی</h2>
                                                    <p>امروزه گجت‌های پوشیدنی از جمله لوازم الکترونیکی قابل استفاده توسط
                                                        کاربران
                                                        هستند. یکی از این گجت‌های پوشیدنی می بندها هستند...</p>
                                                </div>
                                                <div
                                                    className="news-writer d-flex justify-content-between align-items-center">
                                                    <div className="name d-flex align-items-start">
                                                        <img src="./assets/sample-image/Ellipse 146.png"
                                                             className="img-fluid" alt="صوفیا"/>
                                                        <p>صوفیا نصرالهی</p>
                                                    </div>
                                                    <div className="time">
                                                        <p>۳ ساعت قبل</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="news-box">
                                            <div className="news-img">
                                                <img src="./assets/sample-image/DSC02666.png" className="img-fluid"
                                                     alt="گوشی موبایل"/>
                                            </div>
                                            <div className="news-info xp-4">
                                                <div className="news-text">
                                                    <h2>بررسی آیفون SE 2020 اپل</h2>
                                                    <p>شاید حذف کردن جک هدفون از نگاه اپل، شجاعت باشد، اما قطعاً عرضه
                                                        گوشی
                                                        هوشمندی با طراحی تاریخ گذشته در سال 2020 جرئت بیشتری می‌طلبد. به
                                                        نظر
                                                        می‌رسد که شرکت…</p>
                                                </div>
                                                <div
                                                    className="news-writer d-flex justify-content-between align-items-center">
                                                    <div className="name d-flex align-items-start">
                                                        <img src="./assets/sample-image/Ellipse 209.png"
                                                             className="img-fluid" alt="صوفیا"/>
                                                        <p>مهری سیاه‌ریش</p>
                                                    </div>
                                                    <div className="time">
                                                        <p>دیروز</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="news-box">
                                            <div className="news-img">
                                                <img src="./assets/sample-image/تصویر-شاخص-1.png" className="img-fluid"
                                                     alt="گوشی موبایل"/>
                                            </div>
                                            <div className="news-info xp-4">
                                                <div className="news-text">
                                                    <h2>با بهترین گوشی‌های تاشو فعلی بازار آشنا شوید</h2>
                                                    <p>هر چه صفحه نمایش گوشی مورد استفاده‌ی ما بزرگ‌تر باشد، تجربه‌ای که
                                                        در
                                                        حین استفاده از آن خواهیم داشت، لذت‌بخش‌تر خواهد شد. در این بین،
                                                        گوشی‌های تاشو به خاطر داشتن…</p>
                                                </div>
                                                <div
                                                    className="news-writer d-flex justify-content-between align-items-center">
                                                    <div className="name d-flex align-items-start">
                                                        <img src="./assets/sample-image/Ellipse 211.png"
                                                             className="img-fluid" alt="صوفیا"/>
                                                        <p>مسعود سرخابی</p>
                                                    </div>
                                                    <div className="time">
                                                        <p>۳۲ روز قبل</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="news-box">
                                            <div className="news-img">
                                                <img src="./assets/sample-image/6e8c05c67959c9f0dc3fb4df66658358.png"
                                                     className="img-fluid"
                                                     alt="گوشی موبایل"/>
                                            </div>
                                            <div className="news-info xp-4">
                                                <div className="news-text">
                                                    <h2>تفاوت‌های حسگر اثر انگشت اپتیکال و اولتراسونیک: کدام حسگر مناسب
                                                        شماست؟</h2>
                                                    <p>امروزه با افزایش کارایی تلفن‌های همراه، میزان استفاده از آن‌ها
                                                        نیز
                                                        افزایش یافته است. به طبع آ
                                                        هوشمند...</p>
                                                </div>
                                                <div
                                                    className="news-writer d-flex justify-content-between align-items-center">
                                                    <div className="name d-flex align-items-start">
                                                        <img src="./assets/sample-image/Ellipse 213.png"
                                                             className="img-fluid" alt="صوفیا"/>
                                                        <p>لاله جهرمی</p>
                                                    </div>
                                                    <div className="time">
                                                        <p>۳ روز قبل</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="news-box">
                                            <div className="news-img">
                                                <img src="./assets/sample-image/5-2-1280x720.png" className="img-fluid"
                                                     alt="گوشی موبایل"/>
                                            </div>
                                            <div className="news-info xp-4">
                                                <div className="news-text">
                                                    <h2>می‌ بند ۵ معرفی شد: تغییراتی جذاب در مقایسه با نسخه‌ی قبلی</h2>
                                                    <p>امروزه گجت‌های پوشیدنی از جمله لوازم الکترونیکی قابل استفاده توسط
                                                        کاربران
                                                        هستند. یکی از این گجت‌های پوشیدنی می بندها هستند...</p>
                                                </div>
                                                <div
                                                    className="news-writer d-flex justify-content-between align-items-center">
                                                    <div className="name d-flex align-items-start">
                                                        <img src="./assets/sample-image/Ellipse 146.png"
                                                             className="img-fluid" alt="صوفیا"/>
                                                        <p>صوفیا نصرالهی</p>
                                                    </div>
                                                    <div className="time">
                                                        <p>۳ ساعت قبل</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="news-box">
                                            <div className="news-img">
                                                <img src="./assets/sample-image/5-2-1280x720.png" className="img-fluid"
                                                     alt="گوشی موبایل"/>
                                            </div>
                                            <div className="news-info xp-4">
                                                <div className="news-text">
                                                    <h2>می‌ بند ۵ معرفی شد: تغییراتی جذاب در مقایسه با نسخه‌ی قبلی</h2>
                                                    <p>امروزه گجت‌های پوشیدنی از جمله لوازم الکترونیکی قابل استفاده توسط
                                                        کاربران
                                                        هستند. یکی از این گجت‌های پوشیدنی می بندها هستند...</p>
                                                </div>
                                                <div
                                                    className="news-writer d-flex justify-content-between align-items-center">
                                                    <div className="name d-flex align-items-start">
                                                        <img src="./assets/sample-image/Ellipse 146.png"
                                                             className="img-fluid" alt="صوفیا"/>
                                                        <p>صوفیا نصرالهی</p>
                                                    </div>
                                                    <div className="time">
                                                        <p>۳ ساعت قبل</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-block d-lg-none">
                        <div className="news-slider-responsive">
                        <div className="swiper latest-news-swiper  position-relative">
                            <div className="swiper-scrollbar-news position-absolute">
                            </div>
                            <div className="swiper-wrapper">

                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="news-responsive-box position-relative">
                                            <img
                                                src="./assets/sample-image/The-Xiaomi-Mi-10-Pro-exists-and-be-the-first.png"
                                                alt="xiaomi" className="img-fluid"/>
                                            <div className="text-responsive position-absolute">
                                                <h2>پرفروش‌ترین گوشی‌های سه ماهه‌ی اول سال ۲۰۲۰ : مقایسه‌ی آمار جهانی و
                                                    آمار سایمان دیجیتال</h2>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="news-responsive-box position-relative">
                                            <img src="./assets/sample-image/DSC02108-1-280x157.png" className="img-fluid" alt="xiaomi"/>
                                            <div className="text-responsive position-absolute">
                                                <h2>پرفروش‌ترین گوشی‌های سه ماهه‌ی اول سال ۲۰۲۰ : مقایسه‌ی آمار جهانی و
                                                    آمار سایمان دیجیتال</h2>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="news-responsive-box position-relative">
                                            <img
                                                src="./assets/sample-image/The-Xiaomi-Mi-10-Pro-exists-and-be-the-first.png" className="img-fluid"
                                                alt="xiaomi"/>
                                            <div className="text-responsive position-absolute">
                                                <h2>پرفروش‌ترین گوشی‌های سه ماهه‌ی اول سال ۲۰۲۰ : مقایسه‌ی آمار جهانی و
                                                    آمار سایمان دیجیتال</h2>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="news-responsive-box position-relative">
                                            <img src="./assets/sample-image/DSC02108-1-280x157.png" className="img-fluid" alt="xiaomi"/>
                                            <div className="text-responsive position-absolute">
                                                <h2>پرفروش‌ترین گوشی‌های سه ماهه‌ی اول سال ۲۰۲۰ : مقایسه‌ی آمار جهانی و
                                                    آمار سایمان دیجیتال</h2>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LatestNews;
